import React, { useEffect, useState } from "react";
import Header from "../../Core/Header";
import { Section } from "../../Core/Section";
import {
  confirmCheckoutHandle,
  createDeliveryForSell,
  getCheckoutList,
  getCouriersListApi,
  getStoreCheckoutList,
} from "../../Services/Operations/ProductAPI";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { courier } from "../../Services/api_endpoints";

const data=[
    {
        id:1,
        date:"2025-01-01",
        customerName:"John Doe",
        totalAmount:100,
        grandAmount:100,
        status:"paid",
        listofProducts:[
            {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50},
             {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50},
             {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50},
        ],

    },
    {
        id:2,
        date:"2025-01-01",
        customerName:"John Doe",
        totalAmount:100,
        grandAmount:100,
        status:"paid",
        listofProducts:[
            {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50}
        ],

    },
    {
        id:3,
        date:"2025-01-01",
        customerName:"John Doe",
        totalAmount:100,
        grandAmount:100,
        status:"paid",
        listofProducts:[
            {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50}
        ],

    },
    {
        id:4,
        date:"2025-01-01",
        customerName:"John Doe",
        totalAmount:100,
        grandAmount:100,
        status:"paid",
        listofProducts:[
            {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50}
        ],

    },
    {
        id:5,
        date:"2025-01-01",
        customerName:"John Doe",
        totalAmount:100,
        grandAmount:100,
        status:"paid",
        listofProducts:[
            {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50}
        ],

    },
    {
        id:6,
        date:"2025-01-01",
        customerName:"John Doe",
        totalAmount:100,
        grandAmount:100,
        status:"paid",
        listofProducts:[
            {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50}
        ],

    },
    {
        id:7,
        date:"2025-01-01",
        customerName:"John Doe",
        totalAmount:100,
        grandAmount:100,
        status:"paid",
        listofProducts:[
            {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50}
        ],

    },
    {
        id:8,
        date:"2025-01-01",
        customerName:"John Doe",
        totalAmount:100,
        grandAmount:100,
        status:"paid",
        listofProducts:[
            {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50}
        ],

    },
    {
        id:9,
        date:"2025-01-01",
        customerName:"John Doe",
        totalAmount:100,
        grandAmount:100,
        status:"paid",
        listofProducts:[
            {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50}
        ],

    },
    {
        id:10,
        date:"2025-01-01",
        customerName:"John Doe",
        totalAmount:100,
        grandAmount:100,
        status:"paid",
        listofProducts:[
            {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50}
        ],

    },
    {
        id:11,
        date:"2025-01-01",
        customerName:"John Doe",
        totalAmount:100,
        grandAmount:100,
        status:"paid",
        listofProducts:[
            {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50}
        ],

    },
    {
        id:12,
        date:"2025-01-01",
        customerName:"John Doe",
        totalAmount:100,
        grandAmount:100,
        status:"paid",
        listofProducts:[
            {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50}
        ],

    },
    {
        id:13,
        date:"2025-01-01",
        customerName:"John Doe",
        totalAmount:100,
        grandAmount:100,
        status:"paid",
        listofProducts:[
            {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50}
        ],

    },
    {
        id:14,
        date:"2025-01-01",
        customerName:"John Doe",
        totalAmount:100,
        grandAmount:100,
        status:"paid",
        listofProducts:[
            {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50}
        ],

    },
    {
        id:15,
        date:"2025-01-01",
        customerName:"John Doe",
        totalAmount:100,
        grandAmount:100,
        status:"paid",
        listofProducts:[
            {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50}
        ],

    }
    ,{
        id:16,
        date:"2025-01-01",
        customerName:"John Doe",
        totalAmount:100,
        grandAmount:100,
        status:"paid",
        listofProducts:[
            {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50}
        ],

    }
]

// Keep your existing `data` array here, unchanged.

const ConfirmCheckout = () => {
  const navigate = useNavigate();
  const token = useSelector((state) => state.user.token);

  const [conformedCheckout, setConformedCheckout] = useState(data);
  const [createdCheckout, setCreatedCheckout] = useState(data);
  const [all, setAll] = useState(data);

  const [activeIndex, setActiveIndex] = useState(null);
  const [activeItem, setActiveItem] = useState(null);
  const [load, setLoad] = useState(null);

  const [deliveryAssign, setDeliveryAssign] = useState(null);
  const [courierList, setCourierList] = useState([]);
  const [selectedCourier, setSelectedCourier] = useState(null);

  const [trackingNumber, setTrackingNumber] = useState("");
  const [deliveryCost, setDeliveryCost] = useState("");
  const [remarks, setRemarks] = useState("");
  const [expectedDeliveryDate, setExpectedDeliveryDate] = useState(null);
  const [pickupDateTime, setPickupDateTime] = useState(null);
  const [pickupAddress, setPickupAddress] = useState("");

  const fetchCheckouts = async () => {
    if (!token) {
      navigate("/login");
      return;
    }

    try {
      const response = await getCheckoutList(token);
      console.log("Checkout List: ", response);

      const response1 = await getStoreCheckoutList(token);
      console.log("Checkout List store: ", response1);

      setAll(response);

      const created = response.filter(
        (item) => item.orderStatus === "CREATED"
      );

      setCreatedCheckout(created);

      const confirmed = response.filter(
        (item) => item.orderStatus !== "CREATED"
      );

      setConformedCheckout(confirmed);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCourierList = async () => {
    try {
      const response = await getCouriersListApi(token);

      console.log(" courier list", response);

      if (response.status === 200) {
        setCourierList(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchCheckouts();
    fetchCourierList();
  }, []);

  const handleConformedCheckout = async (checkout) => {
    setLoad(checkout);

    try {
      const response = await confirmCheckoutHandle(checkout, token);

      console.log("Conformed Checkout: ", response);

      if (response.status === 200) {
        fetchCheckouts();
        toast.success("Checkout confirmed");
        navigate("/order-add-serial-number")
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoad(null);
    }

    console.log("Conformed Checkout: ", checkout);
  };

  const dateFormate = (date) => {
    let d = new Date(date);
    return d.toLocaleDateString();
  };

  const findCheckout = (id) => {
    let order = all.find((item) => item.checkoutId === id);
    return order;
  };

  const openDetails = (item) => {
    setActiveIndex(item.checkoutId ?? item.id);
    setActiveItem(item);
  };

  const closeDetails = () => {
    setActiveIndex(null);
    setActiveItem(null);
  };

  const openCourierModal = (item) => {
    setDeliveryAssign(item);
  };

  const closeCourierModal = () => {
    setDeliveryAssign(null);
  };

  const handleAssignCourier = async () => {
    try {
      let data = {
        checkoutId: deliveryAssign.checkoutId,
        deliveryAddress: `${deliveryAssign.address},${deliveryAssign.city},${deliveryAssign.district},${deliveryAssign.pincode}`,
        dropoffDateTime: expectedDeliveryDate,
        pickupDateTime,
        pickupAddress,
        courierDetails: {
          courierId: selectedCourier.id,
          trackingNumber,
          expectedDeliveryDate,
          remarks,
          deliveryCost,
        },
      };

      const response = await createDeliveryForSell(data, token);

      console.log(response);

      if (response.status === 200) {
        setDeliveryAssign(null);
        toast.success("Courier assigned successfully");
        handleConformedCheckout(deliveryAssign.checkoutId);
      }

      console.log(data, token);
    } catch (error) {
      console.log(error);
      toast.error("Failed to assign courier");
    }
  };

  const formatAmount = (amount) => {
    if (amount === null || amount === undefined || amount === "") {
      return "0.00";
    }

    return Number(amount).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  return (
    <div id="main_content">
      <Header />

      <div className="page cc-page">
        <Section />

        <div className="section-body cc-section">
          <div className="container-fluid cc-container">

            {/* PAGE HEADER */}
            <div className="cc-page-header">
              <div>
                <span className="cc-eyebrow">ORDER MANAGEMENT</span>
                <h2 className="cc-page-title">Checkout Management</h2>
                <p className="cc-page-subtitle">
                  Review orders, assign couriers and manage checkout status.
                </p>
              </div>

              <div className="cc-header-icon">
                <i className="fa fa-shopping-bag" />
              </div>
            </div>

            {/* IMPORTANT INSTRUCTION */}
            <div className="cc-instruction">
              <div className="cc-instruction-icon">
                <i className="fa fa-info-circle" />
              </div>

              <div>
                <h5>Important instruction</h5>
                <p>
                  Confirm the order at right side, then go to Add serial number
                  for ordered items in next page
                </p>
              </div>
            </div>

            {/* SUMMARY */}
            <div className="cc-summary-grid">
              <div className="cc-summary-card">
                <div className="cc-summary-icon cc-summary-green">
                  <i className="fa fa-check-circle" />
                </div>

                <div>
                  <span>Confirmed Checkouts</span>
                  <h3>{conformedCheckout.length}</h3>
                </div>
              </div>

              <div className="cc-summary-card">
                <div className="cc-summary-icon cc-summary-orange">
                  <i className="fa fa-clock-o" />
                </div>

                <div>
                  <span>Pending Confirmation</span>
                  <h3>{createdCheckout.length}</h3>
                </div>
              </div>

              <div className="cc-summary-card">
                <div className="cc-summary-icon cc-summary-blue">
                  <i className="fa fa-list-alt" />
                </div>

                <div>
                  <span>Total Checkouts</span>
                  <h3>{all.length}</h3>
                </div>
              </div>
            </div>

            {/* CHECKOUT COLUMNS */}
            <div className="cc-columns">

               {/* CREATED CHECKOUTS */}
              <section className="cc-panel cc-created-panel">
                <div className="cc-panel-header">
                  <div className="cc-panel-heading">
                    <div className="cc-panel-heading-icon cc-created-icon">
                      <i className="fa fa-shopping-cart" />
                    </div>

                    <div>
                      <h4>Created Checkouts</h4>
                      <p>Review and confirm these pending orders</p>
                    </div>
                  </div>

                  <span className="cc-count cc-count-created">
                    {createdCheckout.length}
                  </span>
                </div>

                <div className="cc-panel-body">
                  {createdCheckout.length > 0 ? (
                    createdCheckout.map((item) => (
                      <div
                        className="cc-order-card cc-created-card"
                        key={item.checkoutId}
                      >
                        <div className="cc-order-top">
                          <span className="cc-order-id">
                            <i className="fa fa-hashtag" />
                            {item.checkoutId}
                          </span>

                          <span className="cc-order-date">
                            <i className="fa fa-calendar-o" />
                            {dateFormate(item.createdAt)}
                          </span>
                        </div>

                        <div className="cc-customer-row">
                          <div className="cc-avatar cc-created-avatar">
                            {(item.customerName || "C")
                              .trim()
                              .charAt(0)
                              .toUpperCase()}
                          </div>

                          <div className="cc-customer-info">
                            <span>Customer</span>
                            <h5>{item.customerName || "Customer"}</h5>
                          </div>

                          <button
                            type="button"
                            className="cc-icon-button"
                            onClick={() => {
                              if (activeIndex === item.checkoutId) {
                                closeDetails();
                              } else {
                                openDetails(item);
                              }
                            }}
                            title="View order details"
                          >
                            <i className="fa fa-eye" />
                          </button>
                        </div>

                        <div className="cc-order-status-row">
                          <span className="cc-status cc-status-pending">
                            <span className="cc-status-dot" />
                            CREATED
                          </span>

                          <span className="cc-order-label">
                            Awaiting confirmation
                          </span>
                        </div>

                        <div className="cc-amount-row">
                          <div className="cc-amount-box">
                            <span>Total Amount</span>
                            <strong>₹{formatAmount(item.totalAmount)}</strong>
                          </div>

                          <div className="cc-amount-box cc-grand-amount">
                            <span>Grand Amount</span>
                            <strong>₹{formatAmount(item.grandTotal)}</strong>
                          </div>
                        </div>

                        <button
                          type="button"
                          className="cc-confirm-btn"
                          onClick={() => handleConformedCheckout(item.checkoutId)}
                          disabled={load === item.checkoutId}
                        >
                          {load === item.checkoutId ? (
                            <>
                              <i className="fa fa-spinner fa-spin" />
                              Processing...
                            </>
                          ) : (
                            <>
                              Confirm Order
                              <i className="fa fa-arrow-right" />
                            </>
                          )}
                        </button>
                      </div>
                    ))
                  ) : (
                    <div className="cc-empty-state">
                      <div className="cc-empty-icon">
                        <i className="fa fa-inbox" />
                      </div>
                      <h5>No pending checkouts</h5>
                      <p>Newly created orders will appear here.</p>
                    </div>
                  )}
                </div>
              </section>


              {/* CONFIRMED CHECKOUTS */}
              <section className="cc-panel">
                <div className="cc-panel-header">
                  <div className="cc-panel-heading">
                    <div className="cc-panel-heading-icon cc-confirmed-icon">
                      <i className="fa fa-check" />
                    </div>

                    <div>
                      <h4>Confirmed Checkouts</h4>
                      <p>Orders that have already been confirmed</p>
                    </div>
                  </div>

                  <span className="cc-count cc-count-confirmed">
                    {conformedCheckout.length}
                  </span>
                </div>

                <div className="cc-panel-body">
                  {conformedCheckout.length > 0 ? (
                    conformedCheckout.map((item) => (
                      <div
                        className="cc-order-card cc-confirmed-card"
                        key={item.checkoutId ?? item.id}
                      >
                        <div className="cc-order-top">
                          <span className="cc-order-id">
                            <i className="fa fa-hashtag" />
                            {item.checkoutId}
                          </span>

                          <span className="cc-order-date">
                            <i className="fa fa-calendar-o" />
                            {dateFormate(item.createdAt)}
                          </span>
                        </div>

                        <div className="cc-customer-row">
                          <div className="cc-avatar">
                            {(item.customerName || "C")
                              .trim()
                              .charAt(0)
                              .toUpperCase()}
                          </div>

                          <div className="cc-customer-info">
                            <span>Customer</span>
                            <h5>{item.customerName || "Customer"}</h5>
                          </div>

                          <button
                            type="button"
                            className="cc-icon-button"
                            onClick={() => {
                              const currentId = item.checkoutId ?? item.id;

                              if (activeIndex === currentId) {
                                closeDetails();
                              } else {
                                openDetails(item);
                              }
                            }}
                            title="View order details"
                          >
                            <i className="fa fa-eye" />
                          </button>
                        </div>

                        <div className="cc-order-status-row">
                          <span className="cc-status cc-status-confirmed">
                            <span className="cc-status-dot" />
                            {item.orderStatus}
                          </span>

                          <span className="cc-order-label">
                            Confirmed order
                          </span>
                        </div>

                        <div className="cc-amount-row">
                          <div className="cc-amount-box">
                            <span>Total Amount</span>
                            <strong>₹{formatAmount(item.totalAmount)}</strong>
                          </div>

                          <div className="cc-amount-box cc-grand-amount">
                            <span>Grand Amount</span>
                            <strong>₹{formatAmount(item.grandTotal)}</strong>
                          </div>
                        </div>

                        <button
                          type="button"
                          className="cc-view-details-btn"
                          onClick={() => openDetails(item)}
                        >
                          <i className="fa fa-external-link" />
                          View Order Details
                        </button>
                      </div>
                    ))
                  ) : (
                    <div className="cc-empty-state">
                      <div className="cc-empty-icon">
                        <i className="fa fa-check-circle-o" />
                      </div>
                      <h5>No confirmed checkouts</h5>
                      <p>Confirmed orders will appear here.</p>
                    </div>
                  )}
                </div>
              </section>

             
            </div>
          </div>
        </div>

        {/* ORDER DETAILS MODAL */}
        {activeIndex !== null && activeItem && (
          <div className="cc-modal-overlay" onClick={closeDetails}>
            <div
              className="cc-modal cc-details-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="cc-modal-header">
                <div>
                  <span className="cc-modal-eyebrow">ORDER INFORMATION</span>
                  <h3>Checkout Details</h3>
                  <p>Review customer and product information</p>
                </div>

                <button
                  type="button"
                  className="cc-modal-close"
                  onClick={closeDetails}
                >
                  <i className="fa fa-times" />
                </button>
              </div>

              <div className="cc-modal-content">
                <div className="cc-details-customer">
                  <div className="cc-details-avatar">
                    {(activeItem.customerName || "C")
                      .trim()
                      .charAt(0)
                      .toUpperCase()}
                  </div>

                  <div>
                    <span>Customer Name</span>
                    <h4>{activeItem.customerName || "__customer__"}</h4>
                    <small>
                      Checkout ID: {activeItem.checkoutId ?? activeItem.id}
                    </small>
                  </div>
                </div>

                <div className="cc-details-grid">
                  <div className="cc-detail-item">
                    <span>
                      <i className="fa fa-calendar" /> Order Date
                    </span>
                    <strong>
                      {activeItem.createdAt
                        ? dateFormate(activeItem.createdAt)
                        : activeItem.date || "—"}
                    </strong>
                  </div>

                  <div className="cc-detail-item">
                    <span>
                      <i className="fa fa-map-marker" /> City
                    </span>
                    <strong>{activeItem.city || "—"}</strong>
                  </div>

                  <div className="cc-detail-item">
                    <span>
                      <i className="fa fa-location-arrow" /> Address
                    </span>
                    <strong>{activeItem.address || "—"}</strong>
                  </div>

                  <div className="cc-detail-item">
                    <span>
                      <i className="fa fa-map" /> State
                    </span>
                    <strong>{activeItem.state || "—"}</strong>
                  </div>

                  <div className="cc-detail-item">
                    <span>
                      <i className="fa fa-map-pin" /> Pincode
                    </span>
                    <strong>{activeItem.pincode || "—"}</strong>
                  </div>

                  <div className="cc-detail-item">
                    <span>
                      <i className="fa fa-truck" /> Courier
                    </span>
                    <strong>{activeItem.courierName || "Not assigned"}</strong>
                  </div>
                </div>

                <div className="cc-products-section">
                  <div className="cc-products-heading">
                    <div>
                      <h4>Ordered Products</h4>
                      <p>Products included in this checkout</p>
                    </div>

                    <span>
                      {activeItem.items?.length || 0} Items
                    </span>
                  </div>

                  {activeItem.items?.length > 0 ? (
                    <div className="cc-products-list">
                      {activeItem.items.map((product, index) => (
                        <div className="cc-product-row" key={index}>
                          <div className="cc-product-number">
                            {index + 1}
                          </div>

                          <div className="cc-product-info">
                            <strong>{product.productName}</strong>
                            <span>Product #{index + 1}</span>
                          </div>

                          <div className="cc-product-quantity">
                            Qty: {product.quantity}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="cc-no-products">
                      No product information available.
                    </div>
                  )}
                </div>

                <div className="cc-details-footer">
                  <div>
                    <span>Total Amount</span>
                    <strong>₹{formatAmount(activeItem.totalAmount)}</strong>
                  </div>

                  <div>
                    <span>Grand Amount</span>
                    <strong>
                      ₹{formatAmount(activeItem.grandTotal)}
                    </strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* COURIER ASSIGNMENT MODAL */}
        {deliveryAssign !== null && (
          <div
            className="cc-modal-overlay"
            onClick={closeCourierModal}
          >
            <div
              className="cc-modal cc-courier-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="cc-modal-header">
                <div>
                  <span className="cc-modal-eyebrow">
                    DELIVERY CONFIGURATION
                  </span>
                  <h3>Assign Courier</h3>
                  <p>
                    Complete the delivery information to confirm this order.
                  </p>
                </div>

                <button
                  type="button"
                  className="cc-modal-close"
                  onClick={closeCourierModal}
                >
                  <i className="fa fa-times" />
                </button>
              </div>

              <div className="cc-modal-content">
                <div className="cc-assignment-order">
                  <div className="cc-assignment-icon">
                    <i className="fa fa-shopping-bag" />
                  </div>

                  <div>
                    <span>Selected Checkout</span>
                    <strong>{deliveryAssign.checkoutId}</strong>
                    <small>{deliveryAssign.customerName}</small>
                  </div>

                  <span className="cc-status cc-status-pending">
                    CREATED
                  </span>
                </div>

                <div className="cc-form-section">
                  <div className="cc-form-section-title">
                    <i className="fa fa-calendar" />
                    <h5>Delivery Schedule</h5>
                  </div>

                  <div className="cc-form-grid">
                    <div className="cc-form-group">
                      <label>Expected Delivery Date</label>
                      <input
                        type="datetime-local"
                        value={expectedDeliveryDate || ""}
                        onChange={(e) =>
                          setExpectedDeliveryDate(e.target.value)
                        }
                      />
                    </div>

                    <div className="cc-form-group">
                      <label>Pickup Date</label>
                      <input
                        type="datetime-local"
                        value={pickupDateTime || ""}
                        onChange={(e) =>
                          setPickupDateTime(e.target.value)
                        }
                      />
                    </div>
                  </div>
                </div>

                <div className="cc-form-section">
                  <div className="cc-form-section-title">
                    <i className="fa fa-truck" />
                    <h5>Courier Information</h5>
                  </div>

                  <div className="cc-form-grid">
                    <div className="cc-form-group cc-form-full">
                      <label>Courier Service</label>
                      <select
                        value={selectedCourier?.id || ""}
                        onChange={(e) =>
                          setSelectedCourier(
                            courierList.find(
                              (boy) => boy.id === Number(e.target.value)
                            )
                          )
                        }
                      >
                        <option value="">Select Courier Service</option>

                        {courierList.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.courierServiceName}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="cc-form-group">
                      <label>Tracking Number</label>
                      <input
                        type="text"
                        placeholder="Enter tracking number"
                        value={trackingNumber}
                        onChange={(e) =>
                          setTrackingNumber(e.target.value)
                        }
                      />
                    </div>

                    <div className="cc-form-group">
                      <label>Delivery Cost</label>
                      <div className="cc-input-with-prefix">
                        <span>₹</span>
                        <input
                          type="number"
                          placeholder="Enter delivery cost"
                          value={deliveryCost}
                          onChange={(e) =>
                            setDeliveryCost(e.target.value)
                          }
                        />
                      </div>
                    </div>

                    <div className="cc-form-group cc-form-full">
                      <label>Pickup Address</label>
                      <input
                        type="text"
                        placeholder="Enter pickup address"
                        value={pickupAddress}
                        onChange={(e) =>
                          setPickupAddress(e.target.value)
                        }
                      />
                    </div>

                    <div className="cc-form-group cc-form-full">
                      <label>Remarks</label>
                      <textarea
                        rows="3"
                        placeholder="Add any delivery instructions or remarks..."
                        value={remarks}
                        onChange={(e) => setRemarks(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="cc-modal-actions">
                  <button
                    type="button"
                    className="cc-cancel-btn"
                    onClick={closeCourierModal}
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    className="cc-submit-btn"
                    onClick={handleAssignCourier}
                  >
                    <i className="fa fa-check-circle" />
                    Assign Courier & Confirm
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* FOOTER */}
        <div className="section-body">
          <footer className="footer cc-footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  Copyright © 2025{" "}
                  <a href="">
                    Technology support By - Siance Software Pvt Ltd
                  </a>
                  .
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default ConfirmCheckout;